import { Icon, Toast, Tooltip } from '@fattureincloud/fic-design-system'
import {
  faBuilding,
  faStar,
  faSuitcase,
  faUserAstronaut,
  faUserCrown,
} from '@fortawesome/pro-light-svg-icons'
import React, { FC } from 'react'
import { Toggle } from 'react-toggle-component'

import FICColors from '../../common/FICColors'
import { SelectOption } from '../../layout_components/common.components'
import {
  activateEditor,
  disableEditor,
} from '../../redux/features/editor/editorSlice'
import { setRealm } from '../../redux/features/realm/realmSlice'
import {
  setAccountant,
  setAdmin,
  setCompany,
  setReseller,
  VisualizeMode,
} from '../../redux/features/visualizationMode/visualizationModeSlice'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import {
  EditMode,
  EditorOptionChoice,
  FavoriteRealm,
  RealmChoice,
  ToggleLabel,
} from './editormode.components'

interface Props {
  realmChoice?: boolean
}

import { httpRequest, ResponseInterface } from '../../common/network'
import { errorMessage, locale } from '../../locales/locale'
import { activateAdminMode } from '../../redux/features/adminMode/adminModeSlice'

const EditorModeToggle: FC<Props> = (props: Props) => {
  const editorModeActive = useAppSelector((state) => state.editor.value)
  const adminMode = useAppSelector((state) => state.adminMode.value)
  const favoriteRealm = useAppSelector((state) => state.adminMode.favoriteRealm)
  const realm = useAppSelector((state) => state.realm.value)
  const visualizationMode = useAppSelector(
    (state) => state.visualizationMode.value
  )
  const dispatch = useAppDispatch()
  const realmOptions = [
    { id: 0, value: 'fic', label: 'FIC' },
    { id: 1, value: 'dic', label: 'DIC' },
    { id: 2, value: 'resellers', label: 'Resellers' },
    { id: 3, value: 'dic-es', label: 'DIC Spagna' },
  ]

  const visualizeOptions = [
    { id: VisualizeMode.Admin, value: '0', label: locale('Admin') },
    { id: VisualizeMode.Accountant, value: '1', label: locale('Commercialista') },
    { id: VisualizeMode.Company, value: '2', label: locale('Azienda') },
    { id: VisualizeMode.Reseller, value: '3', label: locale('Reseller') },
  ]

  const visualIcon = (
    <div style={{ lineHeight: '32px' }}>
      {visualizationMode === VisualizeMode.Company && (
        <Icon icon={faBuilding} size={'lg'} />
      )}
      {visualizationMode === VisualizeMode.Accountant && (
        <Icon icon={faSuitcase} size={'lg'} />
      )}
      {visualizationMode === VisualizeMode.Reseller && (
        <Icon icon={faUserAstronaut} size={'lg'} />
      )}
      {visualizationMode === VisualizeMode.Admin && (
        <Icon icon={faUserCrown} size={'lg'} />
      )}
    </div>
  )
  //TODO if realm resellres visualizza come becomes reseller or admin, if visualizza come = reseller then realm becomes resellers, vis_accountant, vis_companies are false (and not modificable) if realm = resellers
  const setTitle = (realm: string) => {
    document.title = locale('Guide')
    if (realm === 'fic') {
      return document.title + ' ' + locale('Fatture in Cloud')
    }
    if (realm === 'dic') {
      return document.title + ' ' + locale('Dipendenti in Cloud')
    }
    if (realm === 'dic-es') {
      return document.title + ' ' + locale('Dipendenti in Cloud Spagna')
    }
    return document.title + ' ' + locale('Resellers')
  }

  const updateFavorite = () => {
    httpRequest({
      method: 'PUT',
      path: `help/favorite`,
      data: {
        realm: realm,
      },
      onSuccess: () => dispatch(activateAdminMode(realm)),
      onError: (res: ResponseInterface) => Toast.error(errorMessage, { content: res.message }),
    })
  }

  return (
    <>
      {!adminMode && <></>}
      {adminMode && (
        <EditMode>
          {visualIcon}
          {props.realmChoice && (
            <>
              <EditorOptionChoice>
                <RealmChoice
                  disabled={editorModeActive === true}
                  options={visualizeOptions}
                  onChange={(RealmsOptions: SelectOption) => {
                    if (RealmsOptions.id === 0) {
                      dispatch(setAdmin())
                      return
                    }
                    if (RealmsOptions.id === 1) {
                      dispatch(setAccountant())
                      dispatch(setRealm({ value: 'fic' }))
                      return
                    }
                    if (RealmsOptions.id === 2) {
                      dispatch(setCompany())
                      dispatch(setRealm({ value: 'fic' }))
                      return
                    }
                    if (RealmsOptions.id === 3) {
                      dispatch(setReseller())
                      dispatch(setRealm({ value: 'resellers' }))
                      return
                    }
                  }}
                  label={locale('Visualizza come')}
                  value={visualizeOptions.find((item) => {
                    return item.id === visualizationMode
                  })}
                />
                <RealmChoice
                  options={realmOptions}
                  onChange={(element: SelectOption) => {
                    if (element.value === 'resellers') {
                      if (visualizationMode !== VisualizeMode.Admin && visualizationMode !== VisualizeMode.Reseller) {
                        dispatch(setAdmin())
                      }
                    } else {
                      if (visualizationMode === VisualizeMode.Reseller) {
                        dispatch(setAdmin())
                      }
                    }
                    dispatch(setRealm({ value: element.value }))
                    setTitle(element.value)
                  }}
                  label={locale('Realm')}
                  value={realmOptions.find((item) => {
                    return item.value === realm
                  })}
                />
                <Tooltip message={favoriteRealm === realm ?
                  locale('Preferito') : locale('Setta come Preferito')}
                  placement={'top'} type={'light'}>
                  <FavoriteRealm
                    onClick={() => {
                      if (favoriteRealm === realm) return
                      updateFavorite()
                    }}
                    icon={{ icon: faStar, size: 'lg', color: favoriteRealm === realm ? 'yellow' : 'grey' }}
                  />
                </Tooltip>
              </EditorOptionChoice>
            </>
          )}
          <ToggleLabel htmlFor='toggleEditor'>
            <Toggle
              name={'toggleEditor'}
              checked={editorModeActive}
              onRight={() => {
                dispatch(activateEditor())
                dispatch(setAdmin())
              }}
              onLeft={() => dispatch(disableEditor())}
              knobColor={FICColors.white}
              leftBackgroundColor={FICColors.grey100}
              rightBackgroundColor={FICColors.blue}
              borderColor={FICColors.blue50}
            />
            {locale('Editor Mode')}
          </ToggleLabel>
        </EditMode>
      )}
    </>
  )
}
export default EditorModeToggle
